import React from 'react';
import { Typography } from 'seagull';
export function getQboTooltip(qboItemName, qboClassName) {
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "qbo-tooltip"
  }, /*#__PURE__*/React.createElement(Typography, {
    skin: "invertedStandard",
    variant: "paragraph1"
  }, "This line item is mapped to", ' ', /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph1",
    weight: "bold",
    as: "span",
    "data-testid": "qbo-item-name",
    skin: "invertedStandard"
  }, qboItemName, ' '), qboClassName && /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph1",
    as: "span",
    skin: "invertedStandard"
  }, "with the Class", ' ', /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph1",
    weight: "bold",
    as: "span",
    "data-testid": "qbo-class-name",
    skin: "invertedStandard"
  }, qboClassName)), ' ', "in QuickBooks Online"));
}